package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.workplace.DayTemplateDto
import com.evoapps.evoshift.domain.model.DayTemplate

class DayTemplateMapper {

    fun toDomain(dto: DayTemplateDto): DayTemplate {
        return DayTemplate(
            id = dto.id,
            name = dto.name,
            shiftTemplateIds = dto.shiftTemplateIds
        )
    }

    fun toDto(domain: DayTemplate): DayTemplateDto {
        return DayTemplateDto(
            id = domain.id,
            name = domain.name,
            shiftTemplateIds = domain.shiftTemplateIds
        )
    }
}
